/**
 * Реэкспорт из `@aspid/api-client`.
 *
 * Модуль оставлен, чтобы не трогать импорты в остальном приложении:
 * `@api/apiUtils/ApiResponseError` продолжает работать как раньше.
 *
 * Поле `data` (сырое тело ответа) пришло в общий клиент именно отсюда — из
 * него `isRateLimit429` читает реквизиты плана при 429 (BACK-732). Вместе с
 * ним приложение получает то, чего у него не было: `fields` с field-level
 * ошибками DRF, `getApiFieldErrors` и `Object.setPrototypeOf` + `name`, без
 * которых ломался `instanceof` и Sentry группировал ошибки как безымянные
 * `Error` (AF-13).
 */
export {
  ApiResponseError,
  getApiFieldErrors,
  type ApiResponseErrorProperties,
} from '@aspid/api-client';
